import React, { Component } from "react";
import { Checkbox, Typography, Card, Grid, Button } from "@material-ui/core";
import { Table } from 'antd';
import BusinessIcon from '@material-ui/icons/Business';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PersonIcon from '@material-ui/icons/Person';

class ImportData extends Component {
    state = {
       
    };

    importCompanies = () => {
        this.props.history.push('/settings/import-companies/');
    }

    importPeople = () => {
        this.props.history.push('/settings/import-people/');
    }

    importOpportunity = () => {
        this.props.history.push('/settings/import-opportunities/');
    }

    render() {
        return (
            <React.Fragment>
                <div className="v_scroll crm-custom-importdata-settings">
                    <div className="mb-40">
                        <Typography className=" p-10" variant="h5" color="inherit">Import your Data</Typography>
                        <Typography className="text-hint p-10" variant="p">
                            Import data into IDrive CRM from Google Contacts, CSV files, or Excel files.
                        </Typography>
                    </div>
                    <Card className="p-20 mb-10">
                        <Typography className="font-size-18 p-10" variant="h6" color="inherit">Start a New Import</Typography>
                        <Grid container>
                            <Grid item md={4} className="text-center">
                                <div>
                                    <BusinessIcon className="text-hint font-size-100" style={{fontSize:'80px'}} />
                                </div>
                                <div>
                                    <Button variant="contained" color="primary" onClick={this.importCompanies} size="small">IMPORT COMPANIES</Button>
                                </div>
                            </Grid>
                            <Grid item md={4} className="text-center">
                                <div>
                                    <PersonIcon className="text-hint " style={{ fontSize: '80px' }} />
                                </div>
                                <div>
                                    <Button variant="contained" color="primary" onClick={this.importPeople} size="small">IMPORT PEOPLE</Button>
                                </div>
                            </Grid>
                            <Grid item md={4} className="text-center">
                                <div>
                                    <AttachMoneyIcon className="text-hint" style={{ fontSize: '80px' }}/>
                                </div>
                                <div>
                                    <Button variant="contained" color="primary" onClick={this.importOpportunity} size="small">IMPORT OPPORTUNIRIES</Button>
                                </div>
                                
                            </Grid>
                        </Grid>
                    </Card>
                    <Card className="p-20 mt-10 mb-10">
                        <Typography className="font-size-18 p-10" variant="h6" color="inherit">Past Imports</Typography>
                    </Card>
                    <Card className="p-20 mt-10 mb-10">
                        <Typography className="font-size-18 p-10" variant="h6" color="inherit">Tips For a Smooth Import</Typography>
                        <ul>
                            <li>Import Companies first, then People and then Opportunities. Importing in this order will ensure that all records are related correctly. Leads can be imported at any time.</li>
                            <li>We recommend using our formatted Excel and CSV templates to ensure your data is formatted properly. You'll be given the option to download the templates during the import process. Learn more about the import process here.</li>
                            <li>We support file sizes up to 3MB. If your file is larger than 3MB, we suggest you break it up into multiple files.</li>
                            <li>It's a good idea to do a test with a smaller import file first to make sure your file works.</li>
                            <li>Set up your custom fields and contact types before you import so you can import those fields.</li>
                            <li>The first row of your import file must be the column headers you wish to import to.</li>
                            <li>If a column within the data table does not have a column header, your file will not import properly.</li>
                            <li>If there is data in a cell outside of the data table, your file will not import properly.</li>
                            <li>Importing tags with more than 50 characters will cause that import row to fail.</li>                            
                        </ul>
                    </Card>
                </div>
            </React.Fragment>
        );
    }
}

export default ImportData;
